let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7B7s8")).then(() => parcelRequire('dxRY0'));